// External
import { gql } from "@apollo/client";

export const getTemplateVersionHistoryQuery = gql`
  query getTemplateVersionHistory($input: ReportTemplateVersionHistoryInput!) {
    documentation {
      internalToolsData {
        progressReport {
          templateVersionHistory(input: $input) {
            id
            updatedBy
            updatedAt
          }
        }
      }
    }
  }
`;

export const getTemplateVersionChangesQuery = gql`
  query getTemplateVersionChanges($input: ReportTemplateVersionChangesInput!) {
    documentation {
      internalToolsData {
        progressReport {
          templateVersionChanges(input: $input) {
            section
            path
            field
            action
            oldValue
            newValue
          }
        }
      }
    }
  }
`;
